import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import backgroundAnimation from "../../animations/Animation5.json";
import { useSelector } from "react-redux";
import { MdOutlineCheckCircle, MdListAlt, MdEmail } from "react-icons/md";
import { HiUser } from "react-icons/hi";
import { FaCalendarAlt } from "react-icons/fa";
import "./ResultPage.css";
import API from "../../constants/apiConfig";
import Loader from "../../components/Loader";

function ResultPage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    const fetchResult = async () => {
      try {
        const response = await fetch(`${API.GET_RESULT}${user.id}`, {
          headers: { "Content-Type": "application/json", arkv: "!$Learn#$!" },
        });
        const data = await response.json();

        if (data.error === "False" && data.data.length > 0) {
          setResult(data.data[0]);
        } else {
          console.log("err", data);
          setError("No result data available.");
        }
      } catch (err) {
        console.log("err", err);
        setError("An error occurred while fetching the data.");
      } finally {
        setLoading(false);
      }
    };

    fetchResult();
  }, [user]);

  if (!user) return null;

  if (loading) return <Loader />;

  if (error) {
    return (
      <div className="error-container text-center">
        <h3 className="text-danger">{error}</h3>
      </div>
    );
  }

  const formattedDate = new Date(user?.created_on).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const totalQuestions = parseInt(result?.total_question || 0, 10);
  const totalRight = parseInt(result?.total_right || 0, 10);
  const totalWrong = totalQuestions - totalRight;
  const percentageCorrect =
    totalQuestions > 0 ? ((totalRight / totalQuestions) * 100).toFixed(2) : 0;

  return (
    <div className="main-page">
      {/* Background Animation */}
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>

      {/* Result Card */}
      <Card className="result-card">
        <Card.Body>
          <div className="result-header text-center">
            <h1 className="text-success">
              <MdOutlineCheckCircle className="icon-success" /> Your Result
            </h1>
          </div>

          {/* Result Details */}
          <div className="result-details text-center">
            <h3
              className={`result-percentage ${
                percentageCorrect >= 50 ? "text-success" : "text-danger"
              }`}
            >
              {percentageCorrect}% Correct Answers
            </h3>
            <p>
              <strong>
                <MdListAlt className="icon-detail text-primary" /> Total
                Questions Attempted:
              </strong>{" "}
              {totalQuestions}
            </p>
            <p>
              <strong>
                <MdListAlt className="icon-detail text-primary" /> Correct
                Answers:
              </strong>{" "}
              {totalRight}
            </p>
            <p>
              <strong>
                <MdListAlt className="icon-detail text-primary" /> Wrong
                Answers:
              </strong>{" "}
              {totalWrong}
            </p>
          </div>

          {/* User Details */}
          <div className="user-details text-center">
            <h4 className="text-info">
              <HiUser className="icon-user" /> User Details
            </h4>
            <p>
              <HiUser className="icon-user text-primary" />{" "}
              <strong>Name:</strong> {result?.first_name || "N/A"}
            </p>
            <p>
              <MdEmail className="icon-email text-primary" />{" "}
              <strong>Email:</strong> {result?.email || "N/A"}
            </p>
            <p>
              <FaCalendarAlt className="icon-date text-primary" />{" "}
              <strong>Joined On:</strong> {formattedDate || "Not provided"}
            </p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ResultPage;
